<template>
  <div class="dialog-batch-add-wrapper">
    <el-dialog
      title="批量添加设备"
      :visible="visible"
      :close-on-click-modal="false"
      @open="onDialogOpen"
      @close="onDialogClose">
      <el-form label-position="top" ref="batchAddForm" :rules="batchAddRules" :model="batchAddForm">

        <el-form-item
          label="代理商"
          prop="agentid">
          <el-select
            filterable
            placeholder="选择代理商"
            v-model="batchAddForm.agentid"
            @change="onAgentSelected" >
            <el-option
              v-for="agent in agentList"
              :key="agent.agentid"
              :label="`${agent.agentname}（${agent.nickname}）`"
              :value="agent.agentid">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          label="商户"
          prop="userid"
          v-if="hasRes('user_index') ">
          <el-select v-model="batchAddForm.userid" filterable placeholder="请选择商户">
            <el-option
              v-for="user in userList"
              :key="user.userid"
              :label="user.username"
              :value="user.userid">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          label="厂商"
          prop="factory_id"
          v-if="hasRes('factory_index')" >
          <el-select
            filterable
            default-first-option
            v-model="batchAddForm.factoryId"
            placeholder="请选择设备所属厂商">
            <el-option
              v-for="(factory, index) in factoryList"
              :key="index"
              :label="factory.name"
              :value="factory.factory_id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="设备 IMEI 号（有多个设备 IMEI 号时，一行一个 IMEI 号）" prop="clientids">
          <el-input
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 5 }"
            v-model="batchAddForm.clientids"></el-input>
        </el-form-item>

        <el-form-item label="设备类型" prop="type">
          <el-select v-model="batchAddForm.type" placeholder="请选择设备类型">
            <el-option label="扭蛋机" value="gpm"></el-option>
            <el-option label="自动贩卖机" value="vm"></el-option>
            <el-option label="口红机" value="lpk"></el-option>
            <el-option label="脉冲" value="mc"></el-option>
            <el-option label="福袋机" value="fdj"></el-option>
            <el-option label="格子机" value="gzj"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="设备名" prop="title">
          <el-input v-model="batchAddForm.title"></el-input>
        </el-form-item>

        <el-form-item label="通讯协议" prop="protocol">
          <el-radio v-model="batchAddForm.protocol" label="MQTT">MQTT</el-radio>
          <el-radio v-model="batchAddForm.protocol" label="SOCKET">Socket</el-radio>
        </el-form-item>

        <el-form-item label="通讯是否加密" prop="conn_encry">
          <el-radio v-model="batchAddForm.connEncry" :label="1">加密</el-radio>
          <el-radio v-model="batchAddForm.connEncry" :label="0">不加密</el-radio>
        </el-form-item>

        <el-form-item style="display: flex; justify-content: center;">
          <el-button type="danger" @click="onBatchAddSubmit">确定</el-button>
          <el-button @click="onBatchAddCancel">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { Loading } from 'element-ui'

import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  name: 'DialogBatchAdd',
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      batchAddForm: {
        agentid: 888888,
        userid: 960001,
        factoryId: 1808,
        clientids: '',
        type: 'gpm',
        title: '扭蛋机',
        platform: 'esy',
        protocol: 'MQTT',
        connEncry: 1
      },
      batchAddRules: {
        agentid: [
          { required: true, message: '请选择设备所属代理商', trigger: 'change' }
        ],
        userid: [
          { required: true, message: '请选择设备所属用户', trigger: 'change' }
        ],
        clientids: [
          { required: true, message: '请输入设备 IMEI 号', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择设备类型', trigger: 'change' }
        ],
        title: [
          { required: true, message: '请输入设备名称', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    ...mapState('agent', [
      'agentList'
    ]),
    ...mapState('user', [
      'userList'
    ]),
    ...mapState('factory', [
      'factoryList'
    ]),
    ...mapState('table', [
      'filters'
    ]),
    ...mapGetters('opUser', [
      'hasRes'
    ])
  },
  methods: {
    ...mapActions('agent', [
      'getAgents'
    ]),
    ...mapActions('user', [
      'getUsers'
    ]),
    ...mapActions('device', [
      'batchAdd'
    ]),
    ...mapActions('factory', [
      'getFactories'
    ]),

    async onAgentSelected () {
      this.batchAddForm.userid = ''
      if (this.hasRes('user_index')) {
        try {
          await this.getUsers({
            page: 1,
            pageSize: 9999,
            filters: {
              agentid: this.batchAddForm.agentid
            }
          })
          if (this.userList && this.userList.length > 0) {
            this.batchAddForm.userid = this.userList[0].userid
          }
        } catch (err) {
          console.log(err)
        }
      }
    },

    async onDialogOpen () {
      const now = new Date()
      const month = (now.getMonth() + 1).toString().padStart(2, '0')
      const date = now.getDate()
      this.batchAddForm.title = `${month}-${date}-扭蛋机`
      // Load all user
      if (this.hasRes('agent_index')) {
        try {
          await this.getAgents({
            page: 1,
            pageSize: 9999
          })
        } catch (err) {
          console.log(err)
        }
      }
      if (this.hasRes('user_index')) {
        try {
          await this.getUsers({
            page: 1,
            pageSize: 9999,
            filters: {
              agentid: this.batchAddForm.agentid
            }
          })
        } catch (err) {
          console.log(err)
        }
      }

      if (this.hasRes('factory_index')) {
        this.getFactories({
          page: 1,
          pageSize: 9999
        })
      }
    },
    async onDialogClose () {
      this.$emit('update:visible', false)

      // Restore user list, restore filter condition
      if (this.hasRes('user_index')) {
        try {
          await this.getUsers({
            page: 1,
            pageSize: 9999,
            filters: {
              agentid: this.filters.agentid || ''
            }
          })
        } catch (err) {
          console.log(err)
        }
      }
    },
    onBatchAddSubmit () {
      this.$refs['batchAddForm'].validate(valid => {
        if (valid) {
          const clientIdList = this.batchAddForm.clientids.trim().split('\n')
          for (var item in clientIdList) {
            clientIdList[item] = clientIdList[item].trim()
          }

          const fullLoading = Loading.service({
            fullscreen: true
          })

          // 发送批量添加请求
          this.batchAdd({
            agentid: this.batchAddForm.agentid,
            userid: this.batchAddForm.userid,
            clientids: clientIdList,
            type: this.batchAddForm.type,
            title: this.batchAddForm.title,
            platform: 'esy',
            protocol: this.batchAddForm.protocol,
            connEncry: this.batchAddForm.connEncry,
            factoryId: this.batchAddForm.factoryId
          }).then(res => {
            // 批量添加成功后，将成功添加的设备信息保存成文本文件给用户
            const result = []
            res.data.forEach(item => {
              result.push(`${item.clientid}, ${item.sn}, ${item.url}`)
            })

            const types = {
              'gpm': '扭蛋机',
              'vm': '自动贩卖机',
              'lpk': '口红机',
              'mc': '脉冲',
              'fdj': '福袋机',
              'gzj': '格子机'
            }

            // 创建隐藏的可下载链接
            let eleLink = document.createElement('a')
            eleLink.download = `${types[this.batchAddForm.type]}-${this.batchAddForm.title}-批量入件.txt`
            eleLink.style.display = 'none'

            // 字符内容转变成blob地址
            const blob = new Blob([result.join('\n')])
            eleLink.href = URL.createObjectURL(blob)
            // 触发点击
            document.body.appendChild(eleLink)
            eleLink.click()
            // 然后移除
            document.body.removeChild(eleLink)

            this.$nextTick(() => {
              fullLoading.close()
            })

            this.$refs['batchAddForm'].resetFields()
            this.$message({
              type: 'success',
              message: '批量入件成功'
            })

            this.$emit('data-change')
            this.$emit('update:visible', false)
          }).catch(err => {
            console.log(err)

            this.$nextTick(() => {
              fullLoading.close()
            })
            this.$message({
              type: 'error',
              message: '批量入件失败'
            })
          })
        } else {
          return false
        }
      })
    },
    onBatchAddCancel () {
      this.$emit('update:visible', false)
      this.$refs['batchAddForm'].resetFields()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/sass/base";

</style>



// WEBPACK FOOTER //
// src/components/dev/DialogBatchAdd.vue